{
  "RESET_PASSWORD": {
    "TITLE": "Jelszó megváltoztatása",
    "DESCRIPTION": "Adja meg a kontaktközpontba való bejelentkezéshez használt e-mail címét, hogy megkapja a jelszó-visszaállítási utasításokat.",
    "GO_BACK_TO_LOGIN": "Ha vissza szeretne térni a bejelentkezési oldalra,",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "Kérjük add meg az e-mailcímed.",
      "ERROR": "Kérjük helyes e-mailcímet adj meg."
    },
    "API": {
      "SUCCESS_MESSAGE": "A jelszó helyreállító linket e-mailben elküldtük.",
      "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
    },
    "SUBMIT": "Elküldés"
  }
}
